import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";

const ThumbnailPreview = ({ src, alt = "thumbnail", maxWidth = 300 }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <img
        src={src}
        alt={alt}
        style={{
          maxWidth,
          height: "auto",
          display: "block",
          cursor: "pointer",
          borderRadius: 4,
        }}
        onClick={() => setOpen(true)}
      />
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md">
        <DialogTitle>{alt}</DialogTitle>
        <DialogContent>
          <img
            src={src}
            alt={alt}
            style={{ maxWidth: "100%", height: "auto", display: "block" }}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ThumbnailPreview;


